import { useState } from "react";
import { Button, Form, FormProps, Input, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import usePackage from "stores/usePackage";


import { Steps } from "components/steps/steps";
import { setUserInfo, setUserToken } from "services/storages/userStorage";

import { cognitoUserPool } from "config"; // Import your Cognito User Pool configuration
import { EmailRegex } from "constants/regex";
import PAGES from "routes/constants";
import Logo from "assets/images/logo.png";
import {
  clearSignUpEmail,
  getSignupEmail,
  setConfirmationEmail,
} from "services/storages/userStorage";
import { PASSWORD_INSTRUCTIONS, passwordRegex } from "constants/form";

import "styles/signup.scss";

import {
  clearLastAccessPage,
  getLastAccessPage,
} from "services/storages/expiredStorage";

import {
  getAdemeNumber,
} from "services/storages/userStorage";


function SignupPage() {
  const form = Form.useFormInstance();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);

  const userInfoAWS = cognitoUserPool.getCurrentUser();
  const signupEmail = getSignupEmail();

  const { redirectUrlAfterAuth } = usePackage();


    const handleLogin = async (values: any) => {
      console.log("onFinish:", values);
      try {
        const user = new CognitoUser({
          Username: values.email,
          Pool: cognitoUserPool,
        });
  
        const authDetails = new AuthenticationDetails({
          Username: values.email,
          Password: values.password,
        });
  
        setLoading(true);
        user.authenticateUser(authDetails, {
          onSuccess: (data) => {
            console.log("Login successful:", data);
            setUserToken(data.getAccessToken().getJwtToken() || "");
            setUserInfo(data.getAccessToken().payload);
            setLoading(false);
  
            const lastAccessPage = getLastAccessPage();
            if (redirectUrlAfterAuth) {
              navigate(redirectUrlAfterAuth);
            } else if (lastAccessPage) {
              navigate(lastAccessPage);
              clearLastAccessPage();
            } else {
              navigate(PAGES.home);
            }
          },
          onFailure: (err) => {
            console.error("Login failed:", err);
            messageApi.error("Login failed: " + err.message);
            setLoading(false);
          },
        });
      } catch (e: any) {
        console.log("ERROR", e);
        setLoading(false);
      }
    };
  

  const handleSignup: FormProps["onFinish"] = async (values: any) => {
    console.log("onFinish:", values);
    try {
      setLoading(true);
      const email = values.email || signupEmail;
      const dataEmail = new AmazonCognitoIdentity.CognitoUserAttribute({
        Name: "email",
        Value: email,
      });
      cognitoUserPool.signUp(
        email,
        values.password,
        [dataEmail],
        [],
        (err, data) => {
          if (err) {
            console.error("Signup failed:", err);
            messageApi.error("Signup failed: " + err.message);
          } else {
            console.log("Signup success:", data);
            const refAdeme = getAdemeNumber()
            setConfirmationEmail(values.email);
            clearSignUpEmail();
            // clearAdemeNumber();
            const dashboardUrl = PAGES.dashboard.replace(':id', refAdeme || "");
            handleLogin(values);
            // navigate(dashboardUrl);
            // navigate(PAGES.confirmationSignup);
          }
          setLoading(false);
        }
      );
    } catch (e: any) {
      console.log("ERROR", e);
      setLoading(false);
    }
  };

  return (
    <div className="energy-signup">
      {signupEmail && !userInfoAWS && (
        <Steps stepNames={["offer", "payment", "confirmation"]} />
      )}
      <div className="energy-signup__form">
        {!signupEmail && (
          <img src={Logo} alt="logo" className="w-[203px] h-[175px] mx-auto" />
        )}
        <h1>Créez votre espace checkDPE</h1>

        <Form
          form={form}
          name="signup-form"
          autoComplete="off"
          layout="vertical"
          initialValues={{
            email: signupEmail,
            password: "",
          }}
          onFinish={handleSignup}
        >
          {signupEmail && !userInfoAWS && (
            <p
              style={{
                color: "red",
                marginBottom: "1rem",
                textAlign: "center",
              }}
            >
              Veuillez saisir un mot de passe pour votre compte
            </p>
          )}
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Email is required",
              },
              {
                pattern: EmailRegex,
                message: "Email is invalid",
              },
            ]}
            normalize={(value) => (value ? value.toLowerCase() : "")}
          >
            <Input placeholder="Adresse email" />
          </Form.Item>

          <Form.Item
            name="password"
            trigger="onChange"
            rules={[
              {
                required: true,
                message: "Password is required",
              },
              {
                pattern: passwordRegex,
                message: (
                  <p className="text-[#ff4d4f] text-justify">
                    {PASSWORD_INSTRUCTIONS}
                  </p>
                ),
              },
            ]}
            // extra={
            //   <p className="text-[#1414FF] text-justify">
            //     {PASSWORD_INSTRUCTIONS}
            //   </p>
            // }
          >
            <Input.Password placeholder="Mot de passe" />
          </Form.Item>

          <Button
            htmlType="submit"
            className="btn-connect mt-2"
            loading={loading}
          >
            Continuer
          </Button>
        </Form>

        <Link
          to={PAGES.login}
          className="flex items-center justify-center gap-x-1 underline font-bold text-[16px] mt-10"
          style={{ color: "black" }}
        >
          J&apos;ai déjà un compte{" "}
          <RightOutlined className="relative top-[1px]" />
        </Link>
      </div>

      {contextHolder}
    </div>
  );
}

export default SignupPage;
